import packageInfo from '../../../../package.json';

export const environment = {
  version: `v${packageInfo.version}`,
  /** Shows the banner that says nothing here reaches the real business. */
  testEnvironment: false,
  production: true,
  apiUrl: 'https://api.iqd-pro.com',
  /** The Ask Derek assistant, which is its own service rather than part of the API. */
  insightApiUrl: 'https://insight-api.iqd-pro.com',
  graphql: {
    uri: 'https://api.iqd-pro.com/graphql',
    wsUri: 'wss://api.iqd-pro.com/graphql',
  },
  auth0: {
    domain: 'auth.iqd-pro.com',
    clientId: 'HAby0GpT7tcL8Nrbk9U8PauDqICUS4Tb',
    audience: 'https://api.iqd-pro.com',
    claimsNamespace: 'https://iqd-pro.com/claims/',
    // Auth0 recommends renewing through a first-party silent-auth iframe
    // over holding a refresh token, when the Auth0 domain is same-site
    // with the app: nothing renewable is left at rest for an XSS to read.
    // Where that does not hold — localhost — fall back to refresh tokens.
    useSilentAuth: true,
    /**
     * The Entra ID connection a staff member may link their account to, from
     * the user settings screen. Empty until that connection exists in the
     * tenant, and empty is what hides the option — which is why staging and
     * dev still hold nothing.
     */
    microsoftConnection: 'hi-level-aad',
  },
  sentry: {
    environment: 'production',
    dsn: 'https://9e2076247dd9307fad7340545883ddd0@o4509351712194560.ingest.de.sentry.io/4509351713964112',
    enabled: true,
  },
  links: {
    /** The public 3D viewer, which MezzViewer opens a quote in. */
    viewer3d: 'https://3d-viewer.iqd-pro.com/',
    budgetCalculator: 'https://budget.iqd-pro.com',
  },
  boxOAuth: {
    authorizeUrl: 'https://api.iqd-pro.com/auth/box/authorize',
    tokenUrl: 'https://api.iqd-pro.com/auth/box/token',
  },
  // Feature flags: switch on work that is merged but not yet released, or
  // switch off a screen that is being replaced. Nothing is behind one at the
  // moment; add a boolean here and to the other two environment files.
  features: {},
};
